import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

interface SearchBarProps {
  placeholder?: string;
  onSearch: (value: string) => void;
  debounceMs?: number;
  children?: React.ReactNode;
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = "Search...",
  onSearch,
  debounceMs = 350,
  children,
}) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => onSearch(value), debounceMs);
    return () => clearTimeout(timer);
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <Input
        prefix={<SearchOutlined className="text-gray-400" />}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        allowClear
        style={{ width: 240 }}
      />
      {children}
    </div>
  );
};

export default SearchBar;
